import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const GetInquiryFormInfo = graphql.persisted(
  "GetInquiryFormInfo",
  graphql(`mutation GetInquiryFormInfo($token: String!) {
    getInquiryFormInfo(input: { token: $token }) {
      schoolName
      schoolYearName
      gradeLevels
      userErrors { message path }
    }
  }`)
);

export { GetInquiryFormInfo };
export function useGetInquiryFormInfo() {
  return useMutation(GetInquiryFormInfo);
}
